import ApiService from "../../../services/ApiService";
import Logger from "../../../services/Logger";

const BASE = "/v1/scheduler";

const TaskSchedulerService = {
    list: async (page = 0, pageSize = 10, sort = "createdAt:desc", typeFilter = "all", enabledFilter = "all") => {
        try {
            const params = { page, pageSize, sort };
            if (typeFilter && typeFilter !== "all") {
                params.type = typeFilter;
            }
            if (enabledFilter === "enabled") {
                params.enabled = true;
            }
            const response = await ApiService.getData(BASE, params);
            return { success: true, data: response };
        } catch (error) {
            Logger.error("TaskSchedulerService.list:", error);
            return { success: false, error: error.message || "Failed to fetch task schedules" };
        }
    },

    getById: async (id) => {
        try {
            const response = await ApiService.getData(`${BASE}/${id}`);
            return { success: true, data: response };
        } catch (error) {
            Logger.error("TaskSchedulerService.getById:", error);
            return { success: false, error: error.message || "Failed to fetch task schedule" };
        }
    },

    create: async (body) => {
        try {
            const response = await ApiService.postData(BASE, body);
            return { success: true, data: response };
        } catch (error) {
            Logger.error("TaskSchedulerService.create:", error);
            return { success: false, error: error.message || "Failed to create task schedule" };
        }
    },

    update: async (id, body) => {
        try {
            const response = await ApiService.putData(`${BASE}/${id}`, body);
            return { success: true, data: response };
        } catch (error) {
            Logger.error("TaskSchedulerService.update:", error);
            return { success: false, error: error.message || "Failed to update task schedule" };
        }
    },

    delete: async (id) => {
        try {
            await ApiService.deleteData(`${BASE}/${id}`);
            return { success: true };
        } catch (error) {
            Logger.error("TaskSchedulerService.delete:", error);
            return { success: false, error: error.message || "Failed to delete task schedule" };
        }
    },
};

export default TaskSchedulerService;
